import axios from "axios";

const TOKEN_KEY = "player_token";
const USER_KEY = "player_user";

function getToken() {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || "";
}

function clearAuth() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
}

const http = axios.create({
    baseURL: "", // 走 vue.config.js proxy
    timeout: 15000
});

http.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers.Authorization = "Bearer " + token;
    return config;
});

http.interceptors.response.use(
    (resp) => resp,
    (err) => {
        const msg =
            (err &&
                err.response &&
                err.response.data &&
                (err.response.data.message || err.response.data.msg)) ||
            err.message ||
            "Request failed";

        err._friendlyMessage = msg;

        // ✅ 关键：先不要在这里清 token
        // 因为一旦 header 不匹配导致 401，你会每次刷新都被清掉 token，表现为“刷新掉线”
        if (err && err.response && err.response.status === 401) {
            // 先不清，先保留，让我们确认后端到底认哪个 header
            // localStorage.removeItem("player_token");
            // localStorage.removeItem("player_user");
            // sessionStorage.removeItem("player_token");
            // sessionStorage.removeItem("player_user");
        }

        return Promise.reject(err);
    }
);


export default http;
